import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

const SUGGESTIONS = [
  { label: 'News & Stories', to: '/news', icon: 'ri-newspaper-line' },
  { label: 'Tournaments', to: '/calendar', icon: 'ri-calendar-line' },
  { label: 'Community Board', to: '/community', icon: 'ri-community-line' },
  { label: 'Watch', to: '/watch', icon: 'ri-play-circle-line' },
];

export default function NotFound() {
  return (
    <div className="bg-background-50 text-foreground-950 min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 flex items-center px-4 md:px-8 pt-28 md:pt-36 pb-16 md:pb-24">
        <div className="w-full grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <p className="font-label uppercase tracking-[0.28em] text-xs text-primary-600 font-semibold">Off the fairway</p>
            <p className="font-heading font-extrabold text-primary-100 text-7xl md:text-[9rem] leading-none mt-2">404</p>
            <h1 className="font-heading font-extrabold uppercase text-foreground-950 text-3xl md:text-5xl leading-[1.02] mt-4">
              This page missed the cut.
            </h1>
            <p className="mt-4 text-foreground-700 text-base md:text-lg max-w-xl">
              The page you were looking for isn&apos;t here — it may have moved, or the link was mistyped. Let&apos;s get you back on the course.
            </p>
            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <Link
                to="/"
                className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-label font-bold uppercase tracking-wider text-sm px-6 py-3 rounded-md whitespace-nowrap cursor-pointer transition-colors"
              >
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-home-4-line"></i></span>
                Back to the front page
              </Link>
              <Link
                to="/calendar"
                className="inline-flex items-center justify-center gap-2 border border-foreground-950 text-foreground-950 hover:bg-foreground-950 hover:text-background-50 font-label font-bold uppercase tracking-wider text-sm px-6 py-3 rounded-md whitespace-nowrap cursor-pointer transition-colors"
              >
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-calendar-line"></i></span>
                Browse tournaments
              </Link>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {SUGGESTIONS.map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  className="group flex items-center gap-3 bg-background-100 border border-background-200 hover:border-primary-300 rounded-lg px-5 py-4 cursor-pointer transition-colors"
                >
                  <span className="w-11 h-11 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center text-xl shrink-0 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                    <i className={l.icon}></i>
                  </span>
                  <span className="font-heading font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">{l.label}</span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}